import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { updatePharmacyListTitle } from '../../actions/metaActions';

//TODO import store and use dispatch directly
@connect((store) => {
    return { };
})
class NovatoInfo extends React.Component {

    goToFpact() {
        this.props.history.push('/fpact');
    }
    
    render() {
        return (
            <div>
                <h1>Novato Monday Clinic Info</h1>
                <p>
                    Cost: $0
                    1:30 – 5:00 PM
                    Drop-in
                    Ages 12-21
                </p>
                <button>Map</button>
                <button>Call</button>
                <p>Not age 12-21?</p>
                <button onClick={this.goToFpact.bind(this, true)}>More options</button>
            </div>
        )
    }
}

export default NovatoInfo;


// WEBPACK FOOTER //
// ./src/components/screens/NovatoInfo.js